import { TitleCasePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ProductCardComponent } from '../shared/components/product-card/product-card.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-supermix-lists',
  standalone: true,
  imports: [ProductCardComponent, TitleCasePipe, MatIconModule],
  templateUrl: './supermix-lists.component.html',
  styleUrl: './supermix-lists.component.scss'
})
export class SupermixListsComponent {
  public product: any;
  public promo: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { product: any },
    private dialogRef: MatDialogRef<SupermixListsComponent>

  ) {
    this.product = this.data.product;
    this.getSmartLabel();
  }

  public getSmartLabel() {
    if (this.product.offer_type === 2) {
      this.promo = `${this.product?.restriction} x $${this.product?.smart_offer}`;
    } else if (this.product.offer_type === 3) {
      this.promo = `${this.product?.restriction} x ${this.product?.smart_offer}`;
    } else {
      this.promo = '';
    }
  }

  public closeModal(): void {
    this.dialogRef.close(true);
  }
}
